import { NavItem } from "../types";

export const ROUTES = {
  LOGIN: "/login",
  TEACHER: {
    ROOT: "/teacher",
    DASHBOARD: "/teacher/dashboard",
    STUDENTS: "/teacher/students",
    ATTENDANCE: "/teacher/attendance",
    CONTENT: "/teacher/content",
    INBOX: "/teacher/inbox",
    ARTWORKS: "/teacher/artworks",
  },
  STUDENT: {
    ROOT: "/student",
    DASHBOARD: "/student/dashboard",
    ATTENDANCE: "/student/attendance",
    SUBMISSION: "/student/artwork-submission",
    INBOX: "/student/inbox",
  },
} as const;

export const PAGE_TITLES: Record<string, string> = {
  [ROUTES.TEACHER.ROOT]: "Teacher Portal",
  [ROUTES.TEACHER.DASHBOARD]: "Teacher Dashboard",
  [ROUTES.TEACHER.STUDENTS]: "My Students",
  [ROUTES.TEACHER.ATTENDANCE]: "Student Attendance",
  [ROUTES.TEACHER.CONTENT]: "Content Management",
  [ROUTES.TEACHER.INBOX]: "Teacher Inbox",
  [ROUTES.TEACHER.ARTWORKS]: "Artwork Submitted",
  [`${ROUTES.TEACHER.ROOT}/profile`]: "Teacher Profile",
  [ROUTES.STUDENT.ROOT]: "Student Portal",
  [ROUTES.STUDENT.DASHBOARD]: "Student Dashboard",
  [ROUTES.STUDENT.ATTENDANCE]: "My Attendance",
  [ROUTES.STUDENT.SUBMISSION]: "Artwork Submission",
  [ROUTES.STUDENT.INBOX]: "Student Inbox",
  [`${ROUTES.STUDENT.ROOT}/profile`]: "Student Profile",
};

export const TEACHER_NAV_ITEMS: NavItem[] = [
  { path: ROUTES.TEACHER.DASHBOARD, label: "Dashboard", iconKey: "dashboard" },
  { path: ROUTES.TEACHER.STUDENTS, label: "My Students", iconKey: "students" },
  { path: ROUTES.TEACHER.ATTENDANCE, label: "Attendance", iconKey: "attendance" },
  { path: ROUTES.TEACHER.INBOX, label: "Inbox", iconKey: "inbox" },
  { path: ROUTES.TEACHER.ARTWORKS, label: "Artwork Submitted", iconKey: "artworks" },
];

export const STUDENT_NAV_ITEMS: NavItem[] = [
  { path: ROUTES.STUDENT.DASHBOARD, label: "Dashboard", iconKey: "dashboard" },
  { path: ROUTES.STUDENT.ATTENDANCE, label: "Attendance", iconKey: "attendance" },
  { path: ROUTES.STUDENT.INBOX, label: "Inbox", iconKey: "inbox" },
  { path: ROUTES.STUDENT.SUBMISSION, label: "Artwork Submission", iconKey: "artworks" },
];


